import { createSelector } from 'reselect'
import { RemoteConfigResponse } from 'src/models/remoteConfig.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectRemoteConfigFromState } from 'src/redux/selectors/session.selectors'

export const selectFeatureFlaggerCookiesFromState = (
  state: RootState,
): Partial<RemoteConfigResponse> => state.session.featureFlagger

export const selectFeatureFlaggerFromState = createSelector(
  [selectFeatureFlaggerCookiesFromState, selectRemoteConfigFromState],
  (featureFlagger, remoteConfig) => {
    return {
      ...remoteConfig,
      ...featureFlagger,
    } satisfies RemoteConfigResponse
  },
)
